<template>
  <van-popup v-model:show="state.innerShow" round position="bottom">
    <van-cascader
      v-model="state.value"
      :closeable="false"
      title="请选择位置"
      :options="state.options"
      :field-names="{ text: 'name', value: 'id', children: 'sub_list' }"
      @close="innerShow = false"
      @change="cascaderChange"
    />
    <div style="padding: 10px">
      <van-button
        block
        round
        type="primary"
        style="margin-bottom: 10px"
        @click="cascaderConfirm"
      >
        确定
      </van-button>
      <van-button block round type="success" @click="cascaderReset">
        重置
      </van-button>
    </div>
  </van-popup>
</template>
<script>
import { useVModel } from "@vueuse/core";
import { reactive } from "vue";
import { baseService } from "@/service";
import { Toast } from "vant";
export default {
  name: "Place",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    second: {
      type: Boolean,
      default: false,
    },
  },
  emit: ["confirm"],
  setup(props, { emit }) {
    const state = reactive({
      innerShow: useVModel(props, "show", emit),
      fieldValue: "",
      options: [],
      value: "",
      selected: [],
    });
    const getPlaceList = async () => {
      const { data } = await baseService.placeList();
      state.options = data;
    };

    getPlaceList();

    const cascaderChange = ({ selectedOptions }) => {
      state.selected = selectedOptions;
    };

    const cascaderConfirm = () => {
      if (props.second && state.selected.length == 1) {
        Toast.fail("请选择二级");
        return;
      }
      state.fieldValue = state.selected.map((option) => option.name).join("/");
      emit("confirm", {
        fieldValue: state.fieldValue,
        selected: state.selected,
      });
      state.innerShow = false;
    };

    const cascaderReset = () => {
      state.value = "";
      state.selected = [];
      state.fieldValue = "";
    };
    return {
      state,
      cascaderChange,
      cascaderConfirm,
      cascaderReset,
    };
  },
};
</script>
<style lang="less" scoped></style>
